import { AddressMediasTable } from "@/features/address-medias/address-medias-table";

export default function AddressMediasScreen() {
  return (
    <div className="p-4">
      <AddressMediasTable />
    </div>
  );
}
